module.exports = __webpack_public_path__ + "static/media/huobi-2-full.53f23f18.jpeg";